import styled from 'styled-components';

export const CrossCircleIconWrapper = styled.span`
  width: 23px;
  height: 1.4375em;
  cursor: pointer;
`;

export const LoadingIconContainer = styled.div`
  &&& {
    display: flex;
    align-items: center;
    margin-right: ${({ theme }) => theme.spacing.s2};

    svg {
      margin: 0;
    }
  }
`;
